import { useEffect } from 'react';
import { onCLS, onLCP, onFCP, onTTFB, onINP, type Metric } from 'web-vitals';
import { supabase } from '@/integrations/supabase/client';

interface NavigatorWithConnection extends Navigator {
  connection?: {
    effectiveType?: string;
  };
  deviceMemory?: number;
}

function getRating(metric: Metric): string {
  return metric.rating || 'unknown';
}

async function reportMetric(metric: Metric) {
  try {
    const nav = navigator as NavigatorWithConnection;
    
    await supabase.from('web_vitals').insert({
      metric_name: metric.name,
      metric_value: metric.value,
      rating: getRating(metric),
      page_path: window.location.pathname,
      user_agent: navigator.userAgent,
      connection_type: nav.connection?.effectiveType || null,
      device_memory: nav.deviceMemory || null,
    });
  } catch (error) {
    console.debug('Failed to report web vital:', error);
  }
}

export function useWebVitals() {
  useEffect(() => {
    // Core Web Vitals (LCP, INP, CLS)
    onLCP(reportMetric);
    onINP(reportMetric);
    onCLS(reportMetric);
    
    // Additional metrics
    onFCP(reportMetric);
    onTTFB(reportMetric);
  }, []);
}
